/*
 *+------------------------------------------------------------------------+
 *| Licensed Materials - Property of IBM
 *| IBM Cognos Products: Dashboard
 *| (C) Copyright IBM Corp. 2018
 *|
 *| US Government Users Restricted Rights - Use, duplication or disclosure
 *| restricted by GSA ADP Schedule Contract with IBM Corp.
 *+------------------------------------------------------------------------+
 */
define([], function() {

	const itemIdToViewOptionMap = {
		'com.ibm.bi.dashboard.gridShowUnaggregated': 'gridShowUnaggregated',
		'com.ibm.bi.dashboard.gridRevertToOrginal': 'projectedAggregated',
		'com.ibm.bi.dashboard.gridExportData': 'export'
	};

	class ContextualGridActionController {

		/**
		 * @param  {object} context
		 * @param  {function} [context.target.activeObject.isMenuOptionValid] - optional.
		 * 						A caller can supply a validation function to check whether or not its valid to show
		 * 						an option.  For example, it is not currently valid to show Show Unaggregated items
		 * 						if we have a non contextual TopN defined.
		 * @return {Boolean}
		 */
		isItemVisible(context) {
			if(context.target && context.target.activeObject && context.target.activeObject.content){
				//If a validation function is defined, add the option only if validation passes.
				const fnIsMenuOptionValid = context.target.activeObject.isMenuOptionValid;
				if (!fnIsMenuOptionValid || fnIsMenuOptionValid(context.target.itemId)) {
					const viewOption = this._getViewOptionFromContent(context.target.activeObject.content);
					return viewOption !== this._getViewOptionFromItemId(context.target.itemId);
				}
				return false;
			}
		}

		/**
		 * Callback when select a context menu item
		 *
		 * @param context {object}
		 **/
		onSelectItem(context) {
			const target = context.target;
			const modeOption = this._getViewOptionFromItemId(target.itemId);
			const activeObject = target.activeObject;
			const viewOption = this._getViewOptionFromItemId(target.itemId);
			if ( viewOption === 'export' ) {
				activeObject.export();
			} else {
				// update the viewOption in visGridModel
				activeObject.content.setPropertyValue('datagrid.viewOption', modeOption);
			}
		}

		_getViewOptionFromContent(content) {
			if (content) {
				return content.getPropertyValue('datagrid.viewOption');
			}
		}

		_getViewOptionFromItemId(itemId) {
			return itemIdToViewOptionMap[itemId];
		}
	}

	return ContextualGridActionController;
});
